export default __webpack_public_path__ + "static/media/TIME.313e8050.svg";